
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_h11ix_s5sg5_98",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_s5sg5_104",
  "size-small": "awsui_size-small_h11ix_s5sg5_129",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_s5sg5_133",
  "size-normal": "awsui_size-normal_h11ix_s5sg5_147",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_s5sg5_151",
  "size-medium": "awsui_size-medium_h11ix_s5sg5_165",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_s5sg5_169",
  "size-big": "awsui_size-big_h11ix_s5sg5_183",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_s5sg5_187",
  "size-large": "awsui_size-large_h11ix_s5sg5_201",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_s5sg5_205",
  "variant-normal": "awsui_variant-normal_h11ix_s5sg5_219",
  "variant-disabled": "awsui_variant-disabled_h11ix_s5sg5_222",
  "variant-inverted": "awsui_variant-inverted_h11ix_s5sg5_225",
  "variant-subtle": "awsui_variant-subtle_h11ix_s5sg5_228",
  "variant-warning": "awsui_variant-warning_h11ix_s5sg5_231",
  "variant-error": "awsui_variant-error_h11ix_s5sg5_234",
  "variant-success": "awsui_variant-success_h11ix_s5sg5_237",
  "variant-link": "awsui_variant-link_h11ix_s5sg5_240",
  "badge": "awsui_badge_h11ix_s5sg5_244"
};
  